<template>
    <i id="nav-openHelp" v-tooltip="'Help'" class="fa-light fa-comment-question text-white" @click="openHelp"></i>
</template>

<script lang="ts" setup>
function openHelp() {
    const FreshworksWidget = window.FreshworksWidget;
    FreshworksWidget('open');
}
</script>
